"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LiveNowSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M30 16a13.9 13.9 0 01-2.8 8.37 13.57 13.57 0 01-2.13 2.27 1 1 0 01-1.33-.07 1 1 0 010-1.4 1 1 0 01.06-.06 12.04 12.04 0 001.25-16.98q-.28-.31-.57-.6c-.21-.22-.44-.43-.67-.63a1 1 0 01-.13-1.4.68.68 0 01.06-.07 1 1 0 011.35-.06c.28.23.55.48.8.73a13.56 13.56 0 011.3 1.53A13.9 13.9 0 0130 16zM8.27 26.57a1 1 0 01-1.34.07 13.61 13.61 0 01-2.13-2.27 13.91 13.91 0 010-16.74A13.56 13.56 0 016.1 6.1c.26-.26.52-.5.8-.73a1 1 0 011.35.06 1 1 0 010 1.41l-.06.06c-.23.2-.45.4-.67.62a12 12 0 00.02 16.97q.33.32.67.62a1 1 0 01.11 1.4l-.05.06z"/><path d="M24 16a8 8 0 01-1.11 4.06 8.2 8.2 0 01-2.09 2.33 1.01 1.01 0 01-1.33-.09l-.03-.03a.96.96 0 01.02-1.36.89.89 0 01.12-.1 5.97 5.97 0 001.83-7.4 6.06 6.06 0 00-1.17-1.65 5.71 5.71 0 00-.66-.57 1 1 0 01-.2-1.39.9.9 0 01.1-.11 1.01 1.01 0 011.32-.09 8.1 8.1 0 01.86.74 8.65 8.65 0 011.23 1.6A8 8 0 0124 16zM12.56 22.27l-.04.04a1.01 1.01 0 01-1.32.08 8.2 8.2 0 01-2.09-2.33 7.98 7.98 0 010-8.12 8.7 8.7 0 011.23-1.6 8.1 8.1 0 01.86-.74 1.01 1.01 0 011.32.1 1 1 0 01-.1 1.5 5.71 5.71 0 00-.66.57 6 6 0 00.66 9.04.96.96 0 01.24 1.34 1.06 1.06 0 01-.1.12zM18 16a2.02 2.02 0 11-.59-1.41A1.95 1.95 0 0118 16z"/>';
var LiveNowSVG = function LiveNowSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.LiveNowSVG = LiveNowSVG;
LiveNowSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(LiveNowSVG);
exports.default = _default;